import type { RouteRecordRaw } from 'vue-router';

export default {
  path: '/userscripts',
  name: 'userscripts',
  component: () => import('@/views/dashboard/user-scripts/user-scripts.vue'),
} satisfies RouteRecordRaw;
